var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnackbarInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_299)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.46939C7.84056 4.46939 4.46939 7.84056 4.46939 12C4.46939 16.1595 7.84056 19.5306 12 19.5306C16.1595 19.5306 19.5306 16.1595 19.5306 12C19.5306 7.84056 16.1595 4.46939 12 4.46939ZM12 3C7.02904 3 3 7.02904 3 12C3 16.9709 7.02904 21 12 21C16.9709 21 21 16.9709 21 12C21 7.02904 16.9709 3 12 3Z",
    fill: "#0083A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3469 12C10.3469 11.5943 10.6759 11.2653 11.0816 11.2653H12C12.4057 11.2653 12.7347 11.5943 12.7347 12V16.5918C12.7347 16.9976 12.4057 17.3265 12 17.3265C11.5943 17.3265 11.2653 16.9976 11.2653 16.5918V12.7347H11.0816C10.6759 12.7347 10.3469 12.4057 10.3469 12Z",
    fill: "#0083A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7347 8.55613C12.7347 9.0887 12.303 9.52042 11.7704 9.52042C11.2378 9.52042 10.8061 9.0887 10.8061 8.55613C10.8061 8.02358 11.2378 7.59185 11.7704 7.59185C12.303 7.59185 12.7347 8.02358 12.7347 8.55613Z",
    fill: "#0083A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackbarInfo);
export default __webpack_public_path__ + "static/media/snackbar-info.c8f7aaca906d259e3280f6cd8a77225a.svg";
export { ForwardRef as ReactComponent };